import { featureEnabler, pingUrl } from '@kaltura-ott/tvpil-shared';

import { FEATURES, PING_ENDPOINT, RETRY_COUNT } from 'consts';
import localStorageService from 'services/localStorageService';

class NetworkService {
  private isPending = false;

  private requestURL = localStorageService.getItem(PING_ENDPOINT);

  retryCount: number | undefined = localStorageService.getItem(RETRY_COUNT);

  isConnection = true;

  init() {
    const connectivityPolicy = featureEnabler.variation(FEATURES.CONNECTIVITY_POLICY, {});

    localStorageService.setItem(PING_ENDPOINT, connectivityPolicy?.pingEndpoint || '');
    localStorageService.setItem(RETRY_COUNT, connectivityPolicy?.retryCount || undefined);

    this.requestURL = connectivityPolicy?.pingEndpoint || localStorageService.getItem(PING_ENDPOINT);
    this.retryCount = connectivityPolicy?.retryCount || localStorageService.getItem(RETRY_COUNT);
  }

  setNetworkConnection(value: boolean) {
    this.isConnection = value;
  }

  getResult() {
    return this.isConnection;
  }

  isNetworkConnection = async () => {
    if (this.requestURL) {
      if (!this.isPending) {
        this.isPending = true;
        const isOnline = await pingUrl({ url: this.requestURL });
        this.isPending = false;

        this.setNetworkConnection(isOnline);
      }
    }

    return this.getResult();
  };
}

const networkService = new NetworkService();

export default networkService;
